import { ApproverAll } from './../model/Approver.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User, ChangePassword, GetAllUIobjectResult, UIobjectPermissionSearch, GetUIobjectPermissionResult, Group, GetLoginHistoryResult, GroupPermissionModel, GetGroupListSearch, GetUserPermissionPCResult, MST_USER } from '../model/user.model';
import { Approver } from "../model/Approver.model";
import { MST_COMPANY } from '../model/company.model';


const API_Url = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class UserService {

    private Url = '';  // Url to web api
    currentUser: any;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_Url + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/user';

        // console.log(this.currentUser);
    }

    GetSalesPerson(): Observable<MST_USER[]> {
        return this.http.get<MST_USER[]>(this.Url + '/GetSalesPerson/')
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getUsers(): Observable<User[]> {
        return this.http.get<User[]>(this.Url)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getCompanys(): Observable<MST_COMPANY[]> {
        return this.http.get<MST_COMPANY[]>(this.Url + "/Company/")
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getApprover(level: number): Observable<Approver[]> {
        return this.http.get<Approver[]>(this.Url + "/GetApprover/" + level)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getApproverAll(): Observable<ApproverAll[]> {
        return this.http.get<ApproverAll[]>(this.Url + "/GetApproverAll")
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    GetUserForExport(type: number): Observable<any> {

        return this.http.post(this.Url + '/GetUserForExport/' + type, null, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<{}>('SearchWorkPermit'))
        );
    }

    ChangePassword(data: ChangePassword): Observable<any> {
        return this.http.post<any>(this.Url + "/ChangePassword", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    ChangePasswordWithAdmin(data: ChangePassword): Observable<any> {
        return this.http.post<any>(this.Url + "/ChangePasswordWithAdmin", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    AddUser(data: MST_USER): Observable<any> {
        console.log(data)
        return this.http.post<any>(this.Url + "", data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    GetUserByID(id: number): Observable<MST_USER> {
        return this.http.get<MST_USER>(this.Url + '/' + id.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    getGroupList(): Observable<Group[]> {
        return this.http.post<Group[]>(this.Url + '/GetGroupList', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetAllUIobject(): Observable<Array<GetAllUIobjectResult>> {
        return this.http.get<Array<GetAllUIobjectResult>>(this.Url + '/GetAllUIobject', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetGroupByID(GroupId: number): Observable<any> {
        return this.http.get<any>(this.Url + '/GetGroupByID/' + GroupId.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetUIobjectPermission(search: UIobjectPermissionSearch): Observable<Array<GetUIobjectPermissionResult>> {
        return this.http.post<Array<GetUIobjectPermissionResult>>(this.Url + '/GetUIobjectPermission/', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    GetLoginHistory(id: number): Observable<GetLoginHistoryResult[]> {
        return this.http.get<GetLoginHistoryResult[]>(this.Url + '/GetLoginHistory' + '/' + id, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetUserPermissionPC(id: number): Observable<GetUserPermissionPCResult[]> {
        return this.http.get<GetUserPermissionPCResult[]>(this.Url + '/GetUserPermissionPC' + '/' + id, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    UpdateApprover(data: Approver[]): Observable<any> {
        return this.http.post(this.Url + "/UpdateApprover", data, httpOptions).pipe
            (
                tap(response => { })
            )
    }


    // AddGroupPermission(data: GroupPermission): Observable<any> {
    //     return this.http.post<any>(this.Url + '/AddGroupPermission/', data, httpOptions)
    //         .pipe(
    //             tap(response => {
    //                 // this.log(`fetched `)
    //             })
    //         );
    // }


    AddGroup(data: GroupPermissionModel): Observable<any> {
        return this.http.post<any>(this.Url + '/AddGroup/', data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    UpdateUser(id: number, data: MST_USER): Observable<any> {
        return this.http.put<any>(this.Url + '/' + id.toString(), data, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    GetGroupList(search: GetGroupListSearch): Observable<Array<Group>> {
        return this.http.post<Array<Group>>(this.Url + '/GetGroupList/', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    uploadItemImage(id: number, data: FormData) {
        // const httpOptions = {
        //     headers: new HttpHeaders(
        //         {
        //             // 'Content-Type': 'application/json',
        //             'Authorization': (this.currentUser && this.currentUser.token) ? 'Bearer ' + this.currentUser.token : ''
        //         }
        //     )
        // };
        return this.http.post(this.Url + '/' + id.toString() + "/uploadUserImage", data).pipe(
            tap((res: any) => this.log(res)),
            catchError(this.handleError<any>('uploadError'))
        );
    }

    deleteItemImage(id: number) {
        return this.http.post(this.Url + '/' + id.toString() + "/deleteUserImage", null, httpOptions).pipe(
            tap((res: any) => this.log(res)),
            catchError(this.handleError<any>('deleteImage'))
        );
    }



    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts